import { Story } from "./Story";

export default function StoryPage() {
  return (
    <main data-testid="story-page" className="pt-20">
      <Story />
    </main>
  );
}
